import { ActivatedRoute, NavigationEnd, Router, Params } from '@angular/router';
import { filter } from 'rxjs/operators';
import {AfterContentChecked, Component, OnInit} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { GuideComponent } from 'app/shared/components/guide/guide.component';
import { DropdownMenuOption } from 'app/models/dropdown-menu-option';
import { CompetitionService } from 'app/services/competition.service';
import { AuthService } from 'app/services/auth.service';
import { DialogHelperService } from 'app/services/dialog-helper.service';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-main-navbar',
  templateUrl: './main-navbar.component.html',
  styleUrls: ['./main-navbar.component.scss']
})
export class MainNavbarComponent implements OnInit, AfterContentChecked {
  bsModalRef: BsModalRef;
  isExpanded: boolean;
  errorMessage: boolean;
  hideCompetitonSelector: boolean;
  hideUser: boolean;
  options: Array<DropdownMenuOption>;
  contentOptions: Array<DropdownMenuOption>;
  userOptions: Array<DropdownMenuOption>;
  selected: DropdownMenuOption;
  isAdminUser: boolean;
  competitionPublic: boolean;
  hideUptopLogo: boolean;

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private competitionService: CompetitionService,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private dialogHelper: DialogHelperService
  ) {
    this.hideCompetitonSelector = location.pathname.includes('admin');
    this.isAdminUser = this.auth.isAdminUser();
    this.errorMessage = false;
    this.competitionPublic = false;
    this.hideUser = !this.auth.isAdminUser() && !this.auth.isUser();
  }

  openGuide() {
    this.bsModalRef = this.modalService.show(GuideComponent, {
        class: 'gray modal-lg',
        backdrop: 'static'
    });
  }

  goToHome(): void {
    this.router.navigate([this.competitionService.getCompetitionUrl()]);
  }

  onSelectCompetition(event): void {
    this.selected = event;
    this.router.navigate([event.id],
      {  } ).then(nav => {
        this.selectCompetition(event.id);
      });
  }

  onSelectContentOption(event): void {
    const compUrl = this.competitionService.getCompetitionUrl() || this.competitionService.getCompetitionId();
    if (compUrl) {
      this.router.navigate(['admin', 'competition', compUrl, 'onboarding']);
    } else {
      this.router.navigate([event.id]);
    }
  }

  onSelectUserOption(event): void {
    if (event.id === 'logout') {
      this.auth.logout();
      window.location.href = environment.logout;
      //this.router.navigate(['login'] );
    }
  }

  private selectCompetition(id): void {
    const competition = this.competitionService.getCompetitionSelectedByUrl(id) || this.competitionService.getCompetitionSelectedById(id);
    this.competitionService.setCompetitionSelected(competition);
  }

  private subscribeToRouterEvents(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => this.onNavigationEnd(event.url));
  }

  private onNavigationEnd(url: string): void {
    this.isExpanded = url.includes('search');
    this.hideCompetitonSelector = url.includes('admin');
  }

  private getCompetitions(): void {
    const competition = this.competitionService.getCompetitionSelected(),
      competitions = this.competitionService.getCompetitions();

    if (!competition && !!competitions.length) {
      this.competitionService.setCompetitionSelected(competitions[0]);
    }
    this.options = this.competitionService.getDropdownMenuOptions();
    this.selected = this.options.filter((option) =>
      option.id === this.competitionService.getCompetitionUrl())[0];
    this.redirectToCompetitionId();
  }

  private redirectToCompetitionId(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      // Don't redirect if we are already in the admin competition flow
      if (this.router.url.includes('admin/competition')) {
        return;
      }
      if (!params.id && this.selected) {
        this.router.navigate([this.selected.id]);
      } else if (this.isAdminUser && !this.selected) {
        this.router.navigate(['competition', 'admin']);
      } else if (!this.isAdminUser && !this.selected && params.id) {
        // Competition not found or not accessible without auth — go to login
        this.router.navigate(['login']);
      }
    });
  }

  private getOptionList() {
    this.contentOptions = [
      new DropdownMenuOption('admin', 'Manage content')
    ];

    this.userOptions = [
      new DropdownMenuOption('logout', 'Log out')
    ];
  }

  private handleError() {
    const error = this.competitionService.getError();
    if (error) {
      this.hideCompetitonSelector = true;
      this.errorMessage = true;
      this.dialogHelper.showPrompt(
        'UPTOP Message',
        'Wrong competition URL or competition expired.',
        'OK',
        () => {
          this.competitionService.setError(null);
          if (this.isAdminUser) {
            this.router.navigate(['admin']);
          }
        }
      );
      return false;
    }
    return true;
  }

  ngOnInit() {
    const result = this.handleError();
    if (result)  {
      this.subscribeToRouterEvents();
      this.getOptionList();
      if (!this.hideCompetitonSelector) {
        this.getCompetitions();
      }
    }
  }
  ngAfterContentChecked(): void {
    const comp = this.competitionService.getCompetitionSelected();
    this.hideUptopLogo = !!(comp && comp.hide_uptop_logo);
    if (comp && comp.hasOwnProperty('is_public')) {
      this.competitionPublic = comp.is_public;
      if (comp.is_public && this.hideUser) {
        this.hideCompetitonSelector = true;
      }
    }
  }
}
